import { useQuery } from "@tanstack/react-query"

import { REQUEST_QUOTE_STATUS_QUERY_KEY } from "@/constants/query"

const MOCK_DATA = [
  {
    id: 1,
    name: "В обработке"
  },
  {
    id:2,
    name: "Отклонен"
  },
  {
    id: 3,
    name: "Действующее предложение"
  },
  {
    id: 4,
    name: "Согласован"
  },
  {
    id: 5,
    name: "Закрыт"
  }
]

export const useRequestQuoteStatusesQuery = () => {
  return useQuery({
    queryFn: () => MOCK_DATA,
    queryKey: [REQUEST_QUOTE_STATUS_QUERY_KEY]
  })
}